import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Bookings from "@/pages/Bookings";
import BookingDetail from "@/pages/BookingDetail";
import CalendarPage from "@/pages/CalendarPage";
import Schedine from "@/pages/Schedine";
import Movimentazione from "@/pages/Movimentazione";
import Settings from "@/pages/Settings";
import AuditLog from "@/pages/AuditLog";
import PublicCheckin from "@/pages/PublicCheckin";

function Protected({ children, admin }) {
  const { user } = useAuth();
  if (user === null) {
    return <div className="min-h-screen grid place-items-center text-stone-500" data-testid="auth-loading">Caricamento…</div>;
  }
  if (!user) return <Navigate to="/login" replace />;
  if (admin && user.role !== "admin") return <Navigate to="/" replace />;
  return <Layout>{children}</Layout>;
}

function LoginRoute() {
  const { user } = useAuth();
  if (user) return <Navigate to="/" replace />;
  return <Login />;
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<LoginRoute />} />
          <Route path="/checkin/:token" element={<PublicCheckin />} />
          <Route path="/" element={<Protected><Dashboard /></Protected>} />
          <Route path="/prenotazioni" element={<Protected><Bookings /></Protected>} />
          <Route path="/prenotazioni/:id" element={<Protected><BookingDetail /></Protected>} />
          <Route path="/calendario" element={<Protected><CalendarPage /></Protected>} />
          <Route path="/schedine" element={<Protected><Schedine /></Protected>} />
          <Route path="/movimentazione" element={<Protected><Movimentazione /></Protected>} />
          <Route path="/impostazioni" element={<Protected><Settings /></Protected>} />
          <Route path="/audit" element={<Protected admin><AuditLog /></Protected>} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
      <Toaster richColors position="top-center" />
    </AuthProvider>
  );
}
